import { Button, FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useUser } from 'hooks'
import { useStats } from './lib/ctx/stats'
import { useStatsPermission } from './lib/hooks'

export const StatsDebug = () => {
  const [stats, setDebug, debug] = useStats((s) => [
    s.stats,
    s.setDebug,
    s.debug,
  ])
  const { isInspecting } = useStatsPermission()
  const { colors, mediaQueries } = useTheme()
  const { user } = useUser()

  if (!isInspecting || !debug) return null

  const statsItems = [
    {
      label: 'ID',
      text: stats?.id || '',
    },
    {
      label: 'User ID',
      text: stats?.user?.id || '',
    },
    {
      label: 'Privacy',
      text: stats?.privacy === 'me' ? 'private' : 'public',
    },
    {
      label: 'Theme',
      text: stats?.theme || '',
    },
    {
      label: 'Finished List Privacy',
      text: stats?.is_finished_list_private ? 'private' : 'public',
    },
  ]

  const items = [
    {
      label: 'URL',
      text: window.location.href,
    },
    {
      label: 'Auth User ID',
      text: user?.id || '',
    },
    { label: 'Stats Info', code: statsItems },
  ]

  const getContent = (item: any) => {
    if (item.text) {
      return (
        <Text type="body" sizing="S" align="right">
          {item.text}
        </Text>
      )
    }

    if (item.code) {
      return (
        <code
          className={css`
            padding: 12px;
            display: flex;
            font-size: 10px;
            line-height: 14px;
            flex-direction: column;
            gap: 4px;
            word-break: break-word;
            border-radius: 16px;
            background-color: ${colors.uiSilverGrey};
            overflow-y: auto;
            width: 100%;
            height: 100%;
          `}
        >
          {item.code.map((t: any, i: number) => (
            <span key={i}>
              <b>{t.label}&nbsp;</b>
              {t.text}
            </span>
          ))}
        </code>
      )
    }

    return ''
  }

  return (
    <FlexBox
      className={css`
        padding: 0 20px;
        width: 100%;
        position: fixed;
        bottom: 20px;
        left: 0;
        z-index: 100;
        ${mediaQueries.mobileL} {
          bottom: 40px;
        }
      `}
      justifyContent="center"
    >
      <FlexBox
        className={css`
          gap: 12px;
          width: 100%;
          max-width: 380px;
          padding: 24px;
          background-color: ${colors.uiWhite};
          /* border: 1px solid black; */
          border-radius: 20px;
          position: relative;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        `}
        flexDirection="column"
      >
        <Button
          className={css`
            position: absolute;
            top: 12px;
            right: 12px;
            width: 32px;
            height: 32px;
            background-color: transparent;
            border: none;
            .fds-ui--icon {
              width: 24px;
            }
          `}
          negative
          onClick={() => setDebug(false)}
          icon="close"
        />
        <Text type="subhead" sizing="S">
          Inspector
        </Text>
        <FlexBox
          className={css`
            width: 100%;
            gap: 12px;
          `}
          flexDirection="column"
        >
          {items.map((item, i) => (
            <FlexBox
              key={i}
              className={css`
                width: 100%;
                min-height: 24px;
                justify-content: space-between;
                flex-direction: ${!!item.code ? 'column' : 'row'};
                gap: 8px;
              `}
              justifyContent="space-between"
            >
              <Text
                className={css`
                  flex-shrink: 0;
                `}
                tag="span"
                type="subhead"
                sizing="XS"
              >
                {item.label}
              </Text>
              {getContent(item)}
            </FlexBox>
          ))}
        </FlexBox>
      </FlexBox>
    </FlexBox>
  )
}
